import React, { useEffect, useState } from 'react';

const InfiniteProgressBar = ({ speed = 1 }) => {
  const [progressPercentage, setProgressPercentage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgressPercentage((prevPercentage) =>
        prevPercentage >= 100 ? 0 : prevPercentage + speed
      );
    }, 50);

    return () => clearInterval(interval);
  }, [speed]);

  const progressBarStyle = {
    transform: `translateX(${progressPercentage}%)`
  };

  return (
    <div className="infinite-progress-bar">
      <div className="infinite-progress-bar-fill" style={progressBarStyle}></div>
    </div>
  );
};

export default InfiniteProgressBar;